import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <Result
        status="404"
        title="Lo sentimos, la página que buscas no existe."
        extra={
          <Button
            type="primary"
            onClick={() => navigate(-2)}
          >
            Volver
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
